import React, { useState } from "react";
import { Socket } from "socket.io-client";
import { SocketContext } from "./contextExporter";
import { IUser } from "./AuthContextProvider";

/**
 * Socket bağlantısı devre dışı — AI değerlendirme artık REST üzerinden çalışıyor.
 * Context provider'ı tutuyoruz ki socket kullanan eski bileşenler crash etmesin,
 * ama gerçek bağlantı kurulmuyor.
 */
export function SocketContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [socket] = useState<Socket | null>(null);
  const [isConnected] = useState<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const connectSocket = (_user: IUser) => {
    // Socket devre dışı — bağlantı kurulmuyor
    console.log("Socket devre dışı — AI değerlendirme REST üzerinden çalışıyor");
  };

  const disconnectSocket = () => {
    // no-op
  };

  return (
    <SocketContext.Provider
      value={{ socket, connectSocket, disconnectSocket, isConnected }}
    >
      {children}
    </SocketContext.Provider>
  );
}
